import { z } from 'zod';

import { UnavailableSectionSchema, UnidentifiedSchema } from './sbc-customer';

export const ACCOUNT_HISTORY_TEXT_LIMIT = 300;
export const CREDIT_TRANSACTION_LIMIT = 20;
export const ADMIN_NOTE_LIMIT = 10;
export const ADMIN_ACTION_LIMIT = 20;

export const CREDIT_LEDGERS = ['box_credits', 'add_on_credit'] as const;

export const AccountCreditTransactionSchema = z.object({
  ledger: z.enum(CREDIT_LEDGERS),
  type: z.string(),
  amount: z.number(),
  reason: z.string().nullable(),
  at: z.string().nullable(),
  balanceAfter: z.number().nullable(),
});
export type AccountCreditTransaction = z.infer<typeof AccountCreditTransactionSchema>;

export const AccountAdminNoteSchema = z.object({
  source: z.string(),
  note: z.string(),
  at: z.string().nullable(),
});
export type AccountAdminNote = z.infer<typeof AccountAdminNoteSchema>;

export const AccountAdminActionSchema = z.object({
  action: z.string(),
  at: z.string(),
  by: z.string().nullable(),
  summary: z.string().nullable(),
});
export type AccountAdminAction = z.infer<typeof AccountAdminActionSchema>;

export const CustomerAccountHistoryResultSchema = z.union([
  z.object({
    identified: z.literal(true),
    creditTransactions: z.union([
      z.array(AccountCreditTransactionSchema).max(CREDIT_TRANSACTION_LIMIT),
      UnavailableSectionSchema,
    ]),
    adminNotes: z.union([
      z.array(AccountAdminNoteSchema).max(ADMIN_NOTE_LIMIT),
      UnavailableSectionSchema,
    ]),
    adminActions: z.union([
      z.array(AccountAdminActionSchema).max(ADMIN_ACTION_LIMIT),
      UnavailableSectionSchema,
    ]),
  }),
  UnidentifiedSchema,
]);
export type CustomerAccountHistoryResult = z.infer<typeof CustomerAccountHistoryResultSchema>;
